import { useContext } from 'react';
import useSWR from 'swr';
import { ConfiguratorContext } from '../context';

export const useCustomerTags = () => {

  const configurator = useContext(ConfiguratorContext);

  const fetcher = async () : Promise<string[] | undefined> => {
    const resp = await configurator.api.getCustomerTags();
    return resp.data;
  };

  return useSWR([
    'getCustomerTags',
  ],
    ([_k]) => fetcher(),
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );
};

export default useCustomerTags;
